import { message } from 'antd';

export const AsyncMessage = message;
export default AsyncMessage;

// 对于 antd3 ，为防止 500k 的 icon 包，message使用异步加载（或单独打包 Icon 配合 loader 编译亦可）
/*import { MessageApi } from 'antd/es/message';

const prom: any = () => import1('@libs/a-component/antd/syncs/message');

export const AsyncMessage: MessageApi = [
'info', 'success', 'error', 'warn', 'warning', 'loading', 'open', 'config', 'destroy']
    .reduce((pre, cur) => {
        pre[cur] = (...args): Promise<any> => prom().then(mod => mod.default).then(mod => mod[cur].apply(mod, args));
        return pre;
    }, {}) as any;

export default AsyncMessage;*/

// const message = {
//     info: (...args): Promise<any> => {
//         return load().then(mod => mod.info.apply(mod, args));
//     },
//     success: (...args): Promise<any> => {
//         return load().then(mod => mod.success.apply(mod, args));
//     },
//     error: (...args): Promise<any> => {
//         return load().then(mod => mod.error.apply(mod, args));
//     },
//     warn: (...args): Promise<any> => {
//         return load().then(mod => mod.warn.apply(mod, args));
//     },
//     warning: (...args): Promise<any> => {
//         return load().then(mod => mod.warning.apply(mod, args));
//     },
//     loading: (...args): Promise<any> => {
//         return load().then(mod => mod.loading.apply(mod, args));
//     },
//     open: (...args): Promise<any> => {
//         return load().then(mod => mod.open.apply(mod, args));
//     },
//     config: (...args): Promise<any> => {
//         return load().then(mod => mod.config.apply(mod, args));
//     },
//     destroy: (...args): Promise<any> => {
//         return load().then(mod => mod.destroy.apply(mod, args));
//     },
// };
